import React, { useState } from 'react';
import './Buttons.scss'; // Your SASS file for styling
import ContentCard from './ContentCard';

const Popup = ({ onClose, children }) => {
  return (
    <div className="popup-background" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()}>
        {/* Injected children will be displayed here */}
        {children}
      </div>
    </div>
  );
};

const Buttons = () => {
  const [isPopupOpen, setPopupOpen] = useState(false);

  const openPopup = () => {
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
  };

  return (
    <> {/* This React fragment serves as the parent element */}
      <div className="buttons-container"> {/* This div wraps your buttons and applies the flexbox styling */}
        <button className="btn-default" onClick={closePopup}>Default Button</button>
        <button className="btn-colored" onClick={openPopup}>Colored Button</button>
      </div>
      {isPopupOpen && (
        <Popup onClose={closePopup}>
          <ContentCard />
        </Popup>
      )}
    </>
  );
};

export default Buttons;
